<div class="overview-container">
  <div class="overview-text">
    <sh-text size="super-header" class="overview-title"> Overview </sh-text>
    <sh-text class="overview-description">
      In the healthcare sector, system and clinical workflows are increasing in
      complexity, requiring digital technologies to develop a skilled workforce.
      Offering immersive education solutions to your workforce increases your
      reputation as an innovate employer and can enable you to bring patient
      care to the next level.<br /><br />
      Reduce onboarding time and minimize errors, while providing advanced
      clinical capabilities and skills development with immersive education.
      ExpertGuidance is an Extended Reality training application designed to
      increase your operational efficiency and decrease the time to proficiency
      in regards to equipment onboarding and clinical workflows.
    </sh-text>
  </div>

  <img
    src="assets/images/SS-EG.png"
    alt="ExpertGuidance"
    class="overview-img"
  />
</div>
